export const emptyPatientCard = {
	status: "available",
	patientName: "-",
	diagnosis: "-",
	patientTemperature: "-",
	bloodPressure: "-",
	careRequired: "-",
	doctor: "-",
	admission: "-",
	controls: ["edit", "clear"],

	insuranceType: "",
	planNumber: "",
	policyHolderDate: "",
	policyHolderName: "",
	policyHolderRelationship: "",
	policyIdNumber: "",
	emergencyContactCity: "",
	emergencyContactCountry: "",
	emergencyContactName: "",
	emergencyFirstContactNumber: "",
	emergencySecondContactNumber: "",
	relationship: "",
	adress: "",
	city: "",
	country: "",
	email: "",
	firstContactNumber: "",
	secondContactNumber: "",
	patientAllergies: "",
	patientBloodGroup: "",
	patientChronicCondition: "",
	patientDateBrith: "",
	patientEmployer: "",
	patientEmploymentStatus: "",
	patientGender: "",
	patientId: "",
	patientNationality: "",
	patientOccupation: "",
	patientReligion: "",
};
